<template>
  <div class="device">
    <div class="device-tips">
      最近登录设备：你可以删除列表中的设备，删除后在该设备登录游戏时需要进行身份验证。
    </div>
    <div class="device-list">
      <div class="device-list__item" v-for="item in list" :key="item.id">
        <div class="device-list__name">{{ item.lastLoginEquipment }}{{item.source === 'pc' ? ' 浏览器' : ''}}</div>
        <div class="device-list__time" v-if="item.thisMachine">本机</div>
        <div class="device-list__time">ip:{{ item.sourceClientIp }}</div>
        <div class="device-list__time">
          {{ $common.conversionTime(item.updatedAt) }}
        </div>
        <div class="device-list__del" @click="del(item.id)">删除</div>
      </div>
    </div>
    <p>最多可以绑定10个常用设备</p>
  </div>
</template>

<script>
export default {
  name: 'Device',
  data() {
    return {
      list: [],
    }
  },
  methods: {
    del(id) {
      this.$http
        .get(this.$api.deviceListDel + id)
        .then((res) => {
          if (res.code === 0) {
            this.$message.success('删除成功')
            this.getList()
          }
          else if(res.msg) this.$message({
              message: res.msg,
              type: 'error',
            })
        })
    },
    getList(){
      this.$http
      .get(this.$api.deviceList + (localStorage.fingerprint ?? '123'))
      .then((res) => {
        if (Array.isArray(res?.data)) this.list = res.data
      })
    }
  },
  mounted() {
    this.getList()
  },
}
</script>

<style lang="scss" scoped>
.device {
  padding-top: 15px;
  &-tips {
    height: 30px;
    line-height: 30px;
    background-color: #fff4d7;
    color: #f51c1c;
    font-size: 12px;
    padding-left: 17px;
    margin-bottom: 30px;
  }
  &-list {
    &__item {
      margin-bottom: 10px;
      height: 50px;
      background-color: #eeeeee;
      border-radius: 10px;
      display: flex;
      align-items: center;
      padding-left: 15px;
    }
    &__name {
      font-weight: 700;
      color: #333333;
      font-size: 14px;
    }
    &__time {
      color: #9a9a9a;
      font-size: 12px;
      margin-left: auto;
      & + .device-list__time {
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    &__del {
      color: #fff;
      background-color: #f51c1c;
      border-radius: 0px 10px 10px 0px;
      font-size: 14px;
      height: 100%;
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
  > p {
    color: #cccccc;
    font-size: 12px;
    text-align: center;
    margin-top: 215px;
  }
}
</style>
